var _circle, _circle2, _path, _path2, _rect, _rect2, _ellipse, _ellipse2, _path3, _path4, _rect3, _rect4, _path5, _path6, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeleteListingIc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 141,
    height: 140,
    viewBox: "0 0 141 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 70.5,
    cy: 70,
    r: 70,
    fill: "#F2F5FF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1817_145747",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 141,
    height: 140
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 70.5,
    cy: 70,
    r: 70,
    fill: "#E3E9FF"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1817_145747)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 79.8916H108.496L105.207 154.598H34.7287L30.5 79.8916Z",
    fill: "url(#paint0_linear_1817_145747)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8928 97.388C41.8295 94.7505 43.9503 92.5781 46.5886 92.5781V92.5781C49.1389 92.5781 51.2233 94.6131 51.2845 97.1626L52.4685 146.5C52.5319 149.138 50.411 151.31 47.7727 151.31V151.31C45.2224 151.31 43.1381 149.275 43.0769 146.725L41.8928 97.388Z",
    fill: "url(#paint1_linear_1817_145747)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 58.6914,
    y: 93.9873,
    width: 9.39708,
    height: 58.7318,
    rx: 4.69854,
    fill: "url(#paint2_linear_1817_145747)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 74.1973,
    y: 93.9873,
    width: 9.39708,
    height: 58.7318,
    rx: 4.69854,
    fill: "url(#paint3_linear_1817_145747)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 69.7337,
    cy: 79.6566,
    rx: 38.763,
    ry: 6.81288,
    fill: "url(#paint4_linear_1817_145747)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 69.5,
    cy: 79.5,
    rx: 39,
    ry: 6.5,
    stroke: "#4766DC",
    strokeWidth: 1.40956
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M90.532 97.1626C90.5931 94.6131 92.6775 92.5781 95.2278 92.5781V92.5781C97.8661 92.5781 99.9869 94.7505 99.9236 97.388L98.7395 146.725C98.6783 149.275 96.594 151.31 94.0437 151.31V151.31C91.4054 151.31 89.2846 149.138 89.3479 146.5L90.532 97.1626Z",
    fill: "url(#paint5_linear_1817_145747)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8928 101.617C41.8295 98.979 43.9503 96.8066 46.5886 96.8066V96.8066C49.1389 96.8066 51.2233 98.8416 51.2845 101.391L52.4685 150.729C52.5319 153.366 50.411 155.538 47.7727 155.538V155.538C45.2224 155.538 43.1381 153.503 43.0769 150.954L41.8928 101.617Z",
    fill: "url(#paint6_linear_1817_145747)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 58.6914,
    y: 98.2158,
    width: 9.39708,
    height: 58.7318,
    rx: 4.69854,
    fill: "url(#paint7_linear_1817_145747)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 74.1973,
    y: 98.2158,
    width: 9.39708,
    height: 58.7318,
    rx: 4.69854,
    fill: "url(#paint8_linear_1817_145747)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M90.532 101.391C90.5931 98.8416 92.6775 96.8066 95.2278 96.8066V96.8066C97.8661 96.8066 99.9869 98.979 99.9236 101.617L98.7395 150.954C98.6783 153.503 96.594 155.538 94.0437 155.538V155.538C91.4054 155.538 89.2846 153.366 89.3479 150.729L90.532 101.391Z",
    fill: "url(#paint9_linear_1817_145747)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.1968 52.9577L39.3163 42.8076L37.553 49.3884L37.4922 49.6153L37.5143 49.6212C37.2573 53.3351 53.1937 60.6325 73.6857 66.1233C94.1777 71.6141 111.628 73.2626 113.262 69.9178L113.284 69.9237L113.344 69.6991C113.345 69.6983 113.345 69.6975 113.345 69.6968C113.345 69.696 113.345 69.6952 113.346 69.6944L115.108 63.116L77.2277 52.966C77.2226 52.9646 77.2174 52.9632 77.2123 52.9618C77.2071 52.9604 77.202 52.9591 77.1968 52.9577Z",
    fill: "url(#paint10_linear_1817_145747)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 77.2733,
    cy: 52.7349,
    rx: 39.2328,
    ry: 6.81288,
    transform: "rotate(15 77.2733 52.7349)",
    fill: "url(#paint11_linear_1817_145747)"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 77.304,
    cy: 52.6163,
    rx: 34.0644,
    ry: 5.75065,
    transform: "rotate(15 77.304 52.6163)",
    fill: "url(#paint12_linear_1817_145747)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "darken"
    },
    opacity: 0.9
  }, _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 66.7525,
    cy: 48.489,
    rx: 3.09226,
    ry: 1.02639,
    transform: "rotate(15 66.7525 48.489)",
    fill: "url(#paint13_linear_1817_145747)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "darken"
    },
    opacity: 0.9
  }, _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.09226,
    cy: 1.02639,
    rx: 3.09226,
    ry: 1.02639,
    transform: "matrix(-0.965926 -0.258819 -0.258819 0.965926 92.0059 54.6006)",
    fill: "url(#paint14_linear_1817_145747)"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.3908 40.6021C67.6258 39.7248 68.5276 39.2042 69.4049 39.4393L91.6432 45.398C92.5205 45.6331 93.0411 46.5348 92.8061 47.4121L90.6779 55.3544V55.3544C89.5458 55.7785 88.2694 55.4365 87.501 54.5032V54.5032L89.2035 48.1493L70.1421 43.0418L68.5612 48.9418V48.9418C67.4372 49.4804 66.0884 49.119 65.3843 48.0906V48.0906L67.3908 40.6021Z",
    fill: "url(#paint15_linear_1817_145747)"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M49.75 15V17.5",
    stroke: "#6CCC93",
    strokeWidth: 2,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17.75 65V67.5",
    stroke: "#6CCC93",
    strokeWidth: 2,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M100.75 32V34.5",
    stroke: "#6CCC93",
    strokeWidth: 2,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M124.75 78V80.5",
    stroke: "#6CCC93",
    strokeWidth: 2,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M49.75 23V25.5",
    stroke: "#6CCC93",
    strokeWidth: 2,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M17.75 73V75.5",
    stroke: "#6CCC93",
    strokeWidth: 2,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M100.75 40V42.5",
    stroke: "#6CCC93",
    strokeWidth: 2,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M124.75 86V88.5",
    stroke: "#6CCC93",
    strokeWidth: 2,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M55 20.25L52.5 20.25",
    stroke: "#6CCC93",
    strokeWidth: 2,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M23 70.25L20.5 70.25",
    stroke: "#6CCC93",
    strokeWidth: 2,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M106 37.25L103.5 37.25",
    stroke: "#6CCC93",
    strokeWidth: 2,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M130 83.25L127.5 83.25",
    stroke: "#6CCC93",
    strokeWidth: 2,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M47 20.25L44.5 20.25",
    stroke: "#6CCC93",
    strokeWidth: 2,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M15 70.25L12.5 70.25",
    stroke: "#6CCC93",
    strokeWidth: 2,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M98 37.25L95.5 37.25",
    stroke: "#6CCC93",
    strokeWidth: 2,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M122 83.25L119.5 83.25",
    stroke: "#6CCC93",
    strokeWidth: 2,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1817_145747",
    x1: 72,
    y1: 155,
    x2: 72,
    y2: 92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C2894"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94793,
    stopColor: "#4766DC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1817_145747",
    x1: 47.5273,
    y1: 143.764,
    x2: 47.5273,
    y2: 102.097,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31458F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94793,
    stopColor: "#1B3593"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1817_145747",
    x1: 63.6914,
    y1: 145.173,
    x2: 63.6914,
    y2: 103.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31458F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94793,
    stopColor: "#1B3593"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1817_145747",
    x1: 79.1973,
    y1: 145.173,
    x2: 79.1973,
    y2: 103.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31458F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94793,
    stopColor: "#1B3593"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1817_145747",
    x1: 72.2207,
    y1: 134,
    x2: 72.2207,
    y2: 75.0522,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03124B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.890619,
    stopColor: "#213DA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1817_145747",
    x1: 94.9824,
    y1: 143.764,
    x2: 94.9824,
    y2: 102.097,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31458F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94793,
    stopColor: "#1B3593"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1817_145747",
    x1: 47.5273,
    y1: 169,
    x2: 47.5273,
    y2: 106.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03124B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94793,
    stopColor: "#213DA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1817_145747",
    x1: 63.6914,
    y1: 170.409,
    x2: 63.6914,
    y2: 107.735,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03124B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94793,
    stopColor: "#213DA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1817_145747",
    x1: 79.1973,
    y1: 170.409,
    x2: 79.1973,
    y2: 107.735,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03124B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94793,
    stopColor: "#213DA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1817_145747",
    x1: 94.9824,
    y1: 169,
    x2: 94.9824,
    y2: 106.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03124B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94793,
    stopColor: "#213DA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1817_145747",
    x1: 73.4998,
    y1: 72,
    x2: 78.7902,
    y2: 47.4814,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#092076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94793,
    stopColor: "#4766DC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1817_145747",
    x1: 79.7905,
    y1: 107.078,
    x2: 79.7905,
    y2: 48.1305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03124B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.890619,
    stopColor: "#213DA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1817_145747",
    x1: 78.8695,
    y1: 70.7203,
    x2: 79.464,
    y2: 48.7291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#092076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94793,
    stopColor: "#4766DC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1817_145747",
    x1: 66.9343,
    y1: 52.0751,
    x2: 66.9142,
    y2: 47.4689,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#092076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4766DC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1817_145747",
    x1: 3.92007,
    y1: 6.64027,
    x2: 3.97635,
    y2: -1.6985,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#092076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94793,
    stopColor: "#4766DC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1817_145747",
    x1: 75.1808,
    y1: 64.6959,
    x2: 81.9896,
    y2: 44.7458,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#092076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94793,
    stopColor: "#4766DC"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteListingIc);
export default __webpack_public_path__ + "static/media/delete-listing-ic.102ab5bd2dd0f336ba84c51821630b67.svg";
export { ForwardRef as ReactComponent };